export var Name;
(function (Name) {
    function fromNames(names) {
        return names.length == 1 ? names[0] : `(${names.join(" | ")})`;
    }
    Name.fromNames = fromNames;
    function fromString(name) {
        return !name ? "string" : !Array.isArray(name) ? `'${name}'` : fromNames(name.map(fromString));
    }
    Name.fromString = fromString;
    function fromNumber(name) {
        return !Array.isArray(name) ? name.toString() : fromNames(name.map(fromNumber));
    }
    Name.fromNumber = fromNumber;
    function fromBoolean(name) {
        return name.toString();
    }
    Name.fromBoolean = fromBoolean;
    function fromUnion(base) {
        return fromNames(base.map(b => b.name));
    }
    Name.fromUnion = fromUnion;
    function fromIntersection(base) {
        return base.map(b => b.name).join(" & ");
    }
    Name.fromIntersection = fromIntersection;
    function fromTuple(base) {
        return `[${base.map(b => b.name).join(", ")}]`;
    }
    Name.fromTuple = fromTuple;
    function fromArray(base) {
        return `${base.name}[]`;
    }
    Name.fromArray = fromArray;
})(Name || (Name = {}));
//# sourceMappingURL=Name.js.map